exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".input-dde39{width:220px}", ""]);

// Exports
exports.locals = {
	"input": "input-dde39"
};